/*
 * @Description:
 * @Date: 2021-06-21 21:25:53
 */

export default {
  namespaced: true,
  state: {
    cacheRowChangeFlag: 0, // 类型为时间戳，更变表示生成订单中的【结算任务量】【勾选状态】更改，刷新表格下方统计，在页面中监听了该值进行下侧统计刷新
    cacheKey: '', // 生成订单中全局唯一key，后端必要字段
    request: {}, // 请求器中会混合该参数，在router中清空。userEnterpriseType 1自然人 3园区个体。 项目结算中全局参数，个人或新个体后续接口附带
    payType: '' // 1线上支付 2线下支付
  },
  getters: {
    cacheKey: state => state.cacheKey,
    cacheRowChangeFlag: state => state.cacheRowChangeFlag
  },
  mutations: {
    SET_CACHE_KEY(state, value) {
      state.cacheKey = value;
    },
    SET_COMMON(state, data) {
      state[data.key] = data.value;
    },
    SET_SETTLED: (state, data) => {
      state.request = data;
    },
    SET_PAYTYPE: (state, payload) => {
      state.payType = payload;
    }
  },
  actions: {
    changeInput({ commit }) {
      commit('SET_COMMON', { key: 'cacheRowChangeFlag', value: Date.now() });
    }
  }
};
